import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatchResult, Organization } from '@app/shared/models/dnb';

@Component({
  templateUrl: './company-search-results-dialog.component.html',
  styleUrls: ['./company-search-results-dialog.component.scss'],
})
export class CompanySearchResultsDialogComponent implements OnInit {
  public organisations: Organization[];
  public selectedOrganisation: Organization;
  public runningCreditCheck = false;

  constructor(public dialogRef: MatDialogRef<CompanySearchResultsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: MatchResult) {}

  ngOnInit(): void {
    this.organisations = this.data.matchCandidates.map((x) => x.organization);
  }
}
